// @flow
import {getDeliveryMethodsApi} from './api';
import {ofType, ActionsObservable} from 'redux-observable';
import {map, switchMap} from 'rxjs/operators';
import {
  ActionCreator,
  createReducer,
  buildCatchError,
} from '../../../../store/utils';
import type {Country} from '../../../../entities';
import type {Action} from '../../../../store/utils';

// Temporary types
type PickUpMethod = {
  enabled: boolean,
  type: string,
};

type ShippingMethod = {
  enabled: boolean,
  enabledPromotions: boolean,
  availableShippingCountries: Country[],
  storeShippingMethodPromotion: {
    enabled: boolean,
    minOrderAmount: string,
    price: string,
    tos: string,
    type: string,
  },
  type: string,
};

export type DeliveryMethodsConfigAction = Action & {
  error?: string,
};

export type DeliveryMethodsConfigState = {
  // deliveryMethods?: DeliveryMethod,
  pickupMethod?: PickUpMethod,
  shippingMethod?: ShippingMethod,
  isFetchingDeliveryMethods?: boolean,
  fetchDeliveryMethodsSuccess?: boolean,
  fetchDeliveryMethodsError?: boolean,
};

export const initialState: DeliveryMethodsConfigState = {
  deliveryMethods: undefined,
  isFetchingDeliveryMethods: true,
};

export class FetchDeliveryMethods extends ActionCreator<DeliveryMethodsConfigAction> {}
export class FetchDeliveryMethodsSuccess extends ActionCreator<DeliveryMethodsConfigAction> {}
export class FetchDeliveryMethodsError extends ActionCreator<DeliveryMethodsConfigAction> {}

export const actions = {
  fetchDeliveryMethods: () => new FetchDeliveryMethods(),
};

export default createReducer<DeliveryMethodsConfigState>(initialState, {
  [FetchDeliveryMethods.type]: state => ({
    ...state,
    isFetchingDeliveryMethods: true,
    fetchDeliveryMethodsSuccess: false,
    fetchDeliveryMethodsError: false,
  }),
  [FetchDeliveryMethodsSuccess.type]: (
    state,
    action: DeliveryMethodsConfigAction
  ) => {
    return {
      ...state,
      pickupMethod: action.data.pickUpMethod,
      shippingMethod: action.data.shippingMethod,
      isFetchingDeliveryMethods: false,
      fetchDeliveryMethodsSuccess: true,
      fetchDeliveryMethodsError: false,
    };
  },
  [FetchDeliveryMethodsError.type]: (state, {error}) => ({
    ...state,
    isFetchingDeliveryMethods: false,
    fetchDeliveryMethodsSuccess: false,
    fetchDeliveryMethodsError: true,
  }),
});

export function getLogisticDeliveryMethodsEpic(action$: ActionsObservable) {
  return action$.pipe(
    ofType(FetchDeliveryMethods.type),
    switchMap(() =>
      getDeliveryMethodsApi().pipe(
        map(
          deliveryMethods =>
            new FetchDeliveryMethodsSuccess({data: deliveryMethods})
        ),
        buildCatchError(FetchDeliveryMethodsError)
      )
    )
  );
}
